import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const assetUrl = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const formatINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const authed = async (getToken) => ({ headers: { Authorization: `Bearer ${await getToken()}` } });

export const api = axios;
